module.exports = __webpack_public_path__ + "img/product_51.377ed83.webp";